<div class="env-badge-block" *ngIf="label">
  <span class="env-badge">{{ label }}</span>
  <a class="env-link" [href]="productionUrl" target="_blank" rel="noopener">
    <span i18n="@@env.badge.go.to.production">Go to production</span>
    <span class="arrow" aria-hidden="true">↗</span>
  </a>
</div>
